module.exports = __webpack_public_path__ + "img/avatar-clemens-morris.92d39cfa.jpg";